/* eslint-disable */
import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// import Icon from "@material-ui/core/Icon";
// @material-ui/icons
// import Build from "@material-ui/icons/Build";
// import Subject from "@material-ui/icons/Subject";
// import FormatPaint from "@material-ui/icons/FormatPaint";
// import Code from "@material-ui/icons/Code";
// import Dashboard from "@material-ui/icons/Dashboard";
// import Timeline from "@material-ui/icons/Timeline";
// import Group from "@material-ui/icons/Group";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
// import Button from "components/CustomButtons/Button.jsx";
// import Muted from "components/Typography/Muted.jsx";
// import InfoArea from "components/InfoArea/InfoArea.jsx";
// import Badge from "components/Badge/Badge.jsx";
import Favorite from "@material-ui/icons/NetworkWifi";
import Web from "@material-ui/icons/Web";
import Code from "@material-ui/icons/Code";
import Pages from "@material-ui/icons/Pages";
import Smartphone from "@material-ui/icons/Smartphone";
import Android from "@material-ui/icons/Android";

import Button from "components/CustomButtons/Button.jsx";

import projectsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/projectsStyle.jsx";
// import { Button } from "@material-ui/core";

// import image01 from "assets/img/examples/image-01-full.jpg";
// import image02 from "assets/img/examples/image-02-full.jpg";
// import image03 from "assets/img/examples/image-03-full.jpg";
// import image04 from "assets/img/examples/image-04-full.jpg";
// import image05 from "assets/img/examples/image-05-full.jpg";
// import image06 from "assets/img/examples/image-06-full.jpg";
// import image07 from "assets/img/examples/image-07-full.jpg";
// import image08 from "assets/img/examples/image-08-full.jpg";
// import image09 from "assets/img/examples/image-09-full.jpg";
// import image10 from "assets/img/examples/image-10-full.jpg";
// import image11 from "assets/img/examples/image-11-full.jpg";
// import image12 from "assets/img/examples/image-12-full.jpg";
// import image13 from "assets/img/examples/image-13-full.jpg";
// import image14 from "assets/img/examples/image-14-full.jpg";
// import image15 from "assets/img/examples/image-15-full.jpg";
// import image16 from "assets/img/examples/image-16-full.jpg";
// import image17 from "assets/img/examples/image-17-full.jpg";

// import cardBlog3 from "assets/img/examples/card-blog3.jpg";
// import cardProject1 from "assets/img/examples/card-project1.jpg";
// import cardProject2 from "assets/img/examples/card-project2.jpg";
// import cardProject3 from "assets/img/examples/card-project3.jpg";
// import cardProject4 from "assets/img/examples/card-project4.jpg";
// import cardProject5 from "assets/img/examples/card-project5.jpg";
// import cardProject6 from "assets/img/examples/card-project6.jpg";

function SectionProjects({ ...props }) {
  const { classes, ...rest } = props;
  return (
    <div className="cd-section" {...rest}>
      {/* Project 2 START */}
      <div className={classes.projects}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>
              How To Work With
              </h2>
              <h5 className={classes.description}>
              アプリケーション開発のすすめ方をご確認ください。
              </h5>
              <div className={classes.sectionSpace} />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <Card plain className={classes.card2}>
                <a
                  href="/dx.html#ask"
                >
                  <CardHeader image plain>
                    <img
                      src={
                        "/_include/img/profile/profile-04.jpg"
                      }
                      alt="iOS、androidアプリケーション作成とは"
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url('/_include/img/profile/profile-04.jpg')",
                        opacity: "1"
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/dx.html#ask"
                  >
                    <h4 className={classes.cardTitle}>
                    かんたんDX™️ご依頼の流れ
                    </h4>
                  </a>
                  <h6 className={classes.description}>[お問い合わせ → 完成・運用サポート]</h6>
                  <p
                    className={`${classes.description} ${classes.marginTop20}`}
                  >
                  かんたんDX™️のお問い合わせから完成・運用サポートまで、どのように進むのか？<br/>
                  <Button round
                    className={classes.footerButtons}
                    href="column/internet_rekisi.htm"
                    onClick={e => {}}
                  >
                    <Favorite />インターネットの歴史年表
                  </Button>
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <Card plain className={classes.card2}>
                <a
                  href="/column/android_ios_diff.htm"
                >
                  <CardHeader image plain>
                    <img
                      src="/_include/img/profile/profile-02.jpg"
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url('/_include/img/profile/profile-02.jpg')",
                        opacity: "1"
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/column/android_ios_diff.htm"
                  >
                    <h4 className={classes.cardTitle}>
                    iOSとandroidアプリケーション開発時の対照表
                    </h4>
                  </a>
                  <h6 className={classes.description}>[Cocoa Touch framework x Android SDK]</h6>
                  <p
                    className={`${classes.description} ${classes.marginTop20}`}
                  >
                    iOSアプリケーション作成でいうところのこれはandroidアプリケーション作成ではなんていうのか？<br/>
                    <Button round
                    className={classes.footerButtons}
                    href="/goroku/7/"
                    onClick={e => {}}
                  >
                    <Pages />ブロックチェーン
                  </Button>
                  <Button round
                    className={classes.footerButtons}
                    href="/goroku/1/"
                    onClick={e => {}}
                  >
                    <Smartphone />iOS
                  </Button>
                  <Button round
                    className={classes.footerButtons}
                    href="/goroku/2/"
                    onClick={e => {}}
                  >
                    <Android />android
                  </Button>
                  <Button round
                    className={classes.footerButtons}
                    href="/goroku/8/"
                    onClick={e => {}}
                  >
                    <Web />web
                  </Button>
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <Card plain className={classes.card2}>
                <a
                  href="/software/sk_kokyaku_kanri.htm"
                >
                  <CardHeader image plain>
                    <img
                      src="/_include/img/profile/profile-05.jpg"
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url('/_include/img/profile/profile-05.jpg')",
                        opacity: "1"
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/software/sk_kokyaku_kanri.htm"
                  >
                    <h4 className={classes.cardTitle}>
                    顧客管理システム
                    </h4>
                  </a>
                  <h6 className={classes.description}>Web System</h6>
                  <p
                    className={`${classes.description} ${classes.marginTop20}`}
                  >
                    メールから顧客専用掲示板へシフトしてスパムメールのない仕事環境へ<br/>
                    <Button round
                    className={classes.footerButtons}
                    href="/software/"
                    onClick={e => {}}
                  >
                    <Web />ウェブアプリケーション ショーケース
                  </Button>
                  </p>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      {/* Project 2 END */}
      {/* Project 3 START
      <div
        className={`${classes.projects} ${classes.sectionDark} ${
          classes.projects3
        }`}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <Muted>
                <h6>OUR WORK</h6>
              </Muted>
              <h2 className={classes.title}>
                Some of Our Awesome Products - 3
              </h2>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
              <Card plain className={classes.card2}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <CardHeader plain image>
                    <img src={cardProject1} alt="..." />
                  </CardHeader>
                </a>
                <CardBody>
                  <h6 className={classes.cardCategory}>WEB DESIGN</h6>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <h4 className={classes.cardTitle}>
                      Famous Website Redesign
                    </h4>
                  </a>
                  <p className={classes.cardDescription}>
                    Don't be scared of the truth because we need to restart the
                    human foundation in truth.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>
              <Card plain className={classes.card2}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <CardHeader plain image>
                    <img src={cardProject2} alt="..." />
                  </CardHeader>
                </a>
                <CardBody>
                  <h6 className={classes.cardCategory}>PRODUCTIVITY TOOLS</h6>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <h4 className={classes.cardTitle}>
                      Beautiful Desktop for Designers
                    </h4>
                  </a>
                  <p className={classes.cardDescription}>
                    Don't be scared of the truth because we need to restart the
                    human foundation in truth.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
              <Card plain className={classes.card2}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <CardHeader plain image>
                    <img src={cardProject3} alt="..." />
                  </CardHeader>
                </a>
                <CardBody>
                  <h6 className={classes.cardCategory}>ANDROID APP</h6>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <h4 className={classes.cardTitle}>Analytics for Android</h4>
                  </a>
                  <p className={classes.cardDescription}>
                    Don't be scared of the truth because we need to restart the
                    human foundation in truth.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>
              <Card plain className={classes.card2}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <CardHeader plain image>
                    <img src={cardProject4} alt="..." />
                  </CardHeader>
                </a>
                <CardBody>
                  <h6 className={classes.cardCategory}>WEBSITE</h6>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <h4 className={classes.cardTitle}>Behance Redesign</h4>
                  </a>
                  <p className={classes.cardDescription}>
                    Don't be scared of the truth because we need to restart the
                    human foundation in truth.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div> */}
      {/* Project 3 END */}
      {/* Project 4 START
      <div className={`${classes.projects} ${classes.projects4}`}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>
                Some of Our Awesome Products - 4
              </h2>
              <h5 className={classes.description}>
                This is the paragraph where you can write more details about
                your projects. Keep you user engaged by providing meaningful
                information.
              </h5>
              <div className={classes.sectionSpace} />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
              <Card
                background
                className={classes.card4}
                style={{ backgroundImage: `url(${cardProject2})` }}
              >
                <CardBody background className={classes.cardBody4}>
                  <Badge color="rose">Client: Apple</Badge>
                  <a href="#pablo" onClick={e => e.preventDefault}>
                    <h3 className={classes.cardTitle}>Beautiful Project</h3>
                    <p className={classes.cardDescription}>
                      Don't be scared of the truth because we need to restart
                      the human foundation in truth.
                    </p>
                  </a>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>
              <InfoArea
                className={classes.info4}
                title="Graphic Design"
                description="We've created the design of the website using modern Technologies like Sketch. It was a very interesting collaboration."
                icon={FormatPaint}
                iconColor="info"
              />
              <InfoArea
                className={classes.info4}
                title="Fully Coded in HTML5"
                description="We've developed the website with HTML5 and CSS3. The client has access to the code using GitHub."
                icon={Code}
                iconColor="primary"
              />
              <InfoArea
                className={classes.info4}
                title="CMS Admin Dashboard"
                description="There is also a Fully Customizable CMS Admin Dashboard for this product."
                icon={Dashboard}
                iconColor="danger"
              />
            </GridItem>
          </GridContainer>
          <hr />
          <GridContainer>
            <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
              <InfoArea
                className={classes.info4}
                title="Marketing"
                description="We've created the marketing campaign of the website. It was a very interesting collaboration."
                icon={Timeline}
                iconColor="rose"
              />
              <InfoArea
                className={classes.info4}
                title="Fully Coded in HTML5"
                description="We've developed the website with HTML5 and CSS3. The client has access to the code using GitHub."
                icon={Code}
                iconColor="success"
              />
              <InfoArea
                className={classes.info4}
                title="Built Audience"
                description="There is also a Fully Customizable CMS Admin Dashboard for this product."
                icon={Group}
                iconColor="info"
              />
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>
              <Card
                background
                className={classes.card4}
                style={{ backgroundImage: `url(${cardProject5})` }}
              >
                <CardBody background className={classes.cardBody4}>
                  <Badge color="rose">CLIENT: DJ KHALED</Badge>
                  <a href="#pablo" onClick={e => e.preventDefault}>
                    <h3 className={classes.cardTitle}>Another One</h3>
                    <p className={classes.cardDescription}>
                      Don't be scared of the truth because we need to restart
                      the human foundation in truth.
                    </p>
                  </a>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div> */}
      {/* Project 4 END */}
    </div>
  );
}

export default withStyles(projectsStyle)(SectionProjects);



// WEBPACK FOOTER //
// ./src/views/SectionsPage/Sections/SectionWorkwith.jsx